//
//
//
//
//
//
//

import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
  name: 'ImageViewer',
  props: {
    srcList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      isImage: false
    };
  },
  components: {
    ElImageViewer: ElImageViewer
  },
  methods: {
    openImageViewer: function openImageViewer(url) {
      var _this = this;
      this.isImage = true;
      if (this.srcList.length > 0) {
        this.srcList.map(function (value, index) {
          if (value === url) {
            _this.srcList.splice(index, 1);
          }
        });
        this.srcList.unshift(url);
      }
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
    }
  }
};